import { render, staticRenderFns } from "./tabla_de_requerimientos.vue?vue&type=template&id=18923358&lang=pug&"
import script from "./tabla_de_requerimientos.vue?vue&type=script&lang=js&"
export * from "./tabla_de_requerimientos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports